// extracted by mini-css-extract-plugin
module.exports = {"back-button":"BackButton_back-button__14xT1"};